import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';

import Typography from '../Typography';

import styles, { ListItem } from './styles';

import paleta from '../../configuraciones/paleta';

const defaultLabels = {
  prefijoChip: '',
  listaVacia: 'No hay elementos para mostrar'
};

const ChipSelector = ({ elementos, onClick, elementoID, labels }) => {
  const {
    prefijoChip,
    listaVacia,
  } = { ...defaultLabels, ...labels };

  const classes = styles();

  const handleClick = (elemento) => () => {
    const esMismo = elementoID === elemento.id;
    onClick?.(esMismo ? null : elemento);
  };

  return (
    <Box className={classes.list} component="ul">
      {!elementos.length && (
        <Typography variant="body1" className={classes.mensajeVacio}>{listaVacia}</Typography>
      )}
      {!!elementos.length && elementos.map(({ id, nombre }) => (
        <ListItem key={id}>
          <Chip
            label={prefijoChip + nombre}
            size="small"
            className={clsx(classes.chip, { active: elementoID === id })}
            style={{
              backgroundColor: elementoID === id
                ? paleta.chip.backgroundActive
                : paleta.chip.background
            }}
            onClick={handleClick({ id, nombre })}
          />
        </ListItem>
      ))}
    </Box>
  );
};

ChipSelector.propTypes = {
	elementos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    nombre: PropTypes.string.isRequired,
  })),
  onClick: PropTypes.func,
  elementoID: PropTypes.number,
  labels: PropTypes.shape({
    prefijoChip: PropTypes.string,
    listaVacia: PropTypes.string,
  })
};

ChipSelector.defaultProps = {
  elementos: [],
  onClick: null,
  elementoID: null,
  labels: defaultLabels,
}

export default React.memo(ChipSelector);